export default __webpack_public_path__ + "static/media/Good-01.d6019a02.png";